import { render, staticRenderFns } from "./IlsSettings.vue?vue&type=template&id=2e860df0&"
import script from "./IlsSettings.vue?vue&type=script&lang=js&"
export * from "./IlsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports